import { FC } from 'react'

import styles from './faq-category-info.module.css'
import { Image } from '../image'
import { Heading } from '../heading'
import { FaqCategory as FaqCategoryType } from '../../api'

export interface FaqCategoryInfoProps {
  item: FaqCategoryType
}

export const FaqCategoryInfo: FC<FaqCategoryInfoProps> = ({ item }) => {
  return (
    <div className={styles.container}>
      {item?.icon && (
        <span className={styles.icon}>
          <Image item={item.icon} width={38} height={38} alt={item.icon.alternativeText ?? ''} />
        </span>
      )}
      <div className={styles.mainInfo}>
        <Heading component="h2" theme="h5" className={styles.title}>
          {item.title}
        </Heading>
        <span>{item.faqs?.length} articles</span>
      </div>
    </div>
  )
}
